import {VehicleType} from '../../../../gql/customer/graphql.ts';
import modalStyles from '../../../../components/modal/modal.module.scss';
import {List} from '../../../../components/list/list.tsx';
import React, {useCallback} from 'react';
import {useClickOutside} from '../../../../support/use_click_outside.ts';
import {__} from '../../../../support/lang/translations.ts';
import {VehicleSelectListItem} from '../../../../components/vehicle/vehicle_select_list_item.tsx';

interface OwnProps {
    onCloseModal: () => void;
    vehicles?: (VehicleType | null)[] | null;
    vehicleId: number | null;
    onVehicleIdChange: (vehicleId: number) => void;
}

export function SelectVehicleModal(props: OwnProps) {
    const ref = React.useRef<HTMLDivElement | null>(null);
    const {onCloseModal} = props;
    const closeModalCallback = useCallback(() => {
        onCloseModal();
    }, [onCloseModal]);
    useClickOutside(ref, closeModalCallback);

    const onVehicleSelect = (vehicleId: number | null) => {
        if (vehicleId) {
            props.onVehicleIdChange(vehicleId);
            onCloseModal();
        }
    };

    return (
        <div className={modalStyles.modal_backdrop}>
            <div className={modalStyles.modal}>
                <div className={modalStyles.modal_dialog} ref={ref}>
                    <div className={modalStyles.modal_header}>
                        <span />
                        <h2>{__('appointment.vehicle_select.modals.titles.select')}</h2>
                        <button type="button" onClick={() => onCloseModal()}>
                            <i className="fa-light fa-close"></i>
                        </button>
                    </div>
                    <div className={modalStyles.modal_body}>
                        <List>
                            {props.vehicles?.map(
                                (vehicle) =>
                                    vehicle?.id != null && (
                                        <VehicleSelectListItem
                                            key={vehicle.id}
                                            selectedVehicleId={props.vehicleId}
                                            vehicle={vehicle}
                                            onClick={onVehicleSelect}
                                        />
                                    ),
                            )}
                        </List>
                    </div>
                </div>
            </div>
        </div>
    );
}
